import type { XviewPerfTimingRegistry } from "./firstApiTiming";

export function registerSelfScript(): void {
  if (typeof window === "undefined" || typeof document === "undefined") return;
  const selfSrc =
    (document.currentScript as HTMLScriptElement | null)?.src ?? null;
  if (!selfSrc) return;
  const ns = (window.__xviewPerfTiming__ ??= {} as XviewPerfTimingRegistry);
  const urls = (ns.excludedInstrumentationScriptUrls ??= []);
  if (!urls.includes(selfSrc)) urls.push(selfSrc);
}
